import React from "react";
import { Link, useLocation } from "react-router-dom";
import { openConsult } from "../lib/api";

export default function Nav() {
  const loc = useLocation();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const isActive = (p) => loc.pathname === p;
  const linkClass = (p) =>
    `font-typewriter text-sm lg:text-base tracking-[0.25em] uppercase transition ${
      isActive(p) ? "text-[#D9739A]" : "text-[#1F1B18] hover:text-[#D9739A]"
    }`;

  const tabs = [
    { to: "/miles", label: "The Founder" },
  ];

  return (
    <nav className="w-full border-b border-[#1F1B18]/20 bg-[#F8F2E8] sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          onClick={() => setMobileOpen(false)}
          className="font-cormorant text-xl sm:text-2xl tracking-[0.35em] uppercase text-[#1F1B18]"
        >
          Ask Kimberley
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {tabs.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              data-testid={`nav-${t.label.toLowerCase().replace(/ /g, "-")}`}
              className={linkClass(t.to)}
            >
              {t.label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => openConsult("Partner with Us")}
          data-testid="nav-partner"
          className="hidden md:inline-flex items-center justify-center border border-[#1F1B18] text-[#1F1B18] px-6 py-3 font-typewriter text-sm tracking-[0.25em] uppercase hover:bg-[#1F1B18] hover:text-[#F8F2E8] transition"
        >
          Partner with Us
        </button>

        <button
          className="md:hidden font-typewriter text-base tracking-[0.3em] uppercase text-[#1F1B18]"
          onClick={() => setMobileOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {mobileOpen ? "close ×" : "menu ≡"}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-[#1F1B18]/20 bg-[#F8F2E8] px-6 py-6 space-y-5" data-testid="nav-mobile-menu">
          {tabs.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              onClick={() => setMobileOpen(false)}
              className={`block ${linkClass(t.to)}`}
            >
              {t.label}
            </Link>
          ))}
          <button
            onClick={() => { setMobileOpen(false); openConsult("Partner with Us"); }}
            className="inline-flex items-center justify-center border border-[#1F1B18] text-[#1F1B18] px-6 py-3 font-typewriter text-sm tracking-[0.25em] uppercase"
          >
            Partner with Us
          </button>
        </div>
      )}
    </nav>
  );
}
